import {
  doc,
  onSnapshot,
  FirestoreError,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../firebase";
import { EntityGet, EntityServerGet, OnSnapshotDocService } from "../types";
import { Agent } from "./types";
import { transformMetadata, processTimestampFields } from "../utils";

export type AgentOnSnapshotDocService<T> = (
  id: string,
  callback: (doc: T) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotDoc: AgentOnSnapshotDocService<EntityGet<Agent>> = (
  id,
  callback,
  onError
) => {
  const docRef = doc(db, `/agent/${id}`);
  return onSnapshot(
    docRef,
    (docSnap) => {
      if (docSnap.exists()) {
        callback(
          processTimestampFields(
            transformMetadata(
              {
                ...docSnap.data(),
                id: docSnap.id,
              } as EntityServerGet<Agent>,
              docSnap.metadata
            )
          ) as EntityGet<Agent>
        );
      } else {
        onError?.({
          name: "FirestoreError",
          code: "not-found",
          message: `Document "${id}" was not found`,
        });
      }
    },
    onError
  );
};

export default onSnapshotDoc;
